import { colors } from "@mui/material";
import { PaymentOutStatus } from "Domain/PaymentPlan/Entity/PaymentPlan";
import StatusChip from "./StatusChip";
import { useTranslation } from "react-i18next";

type PaymentOutStatusProps = {
  status: PaymentOutStatus;
};

const statusColors: Record<PaymentOutStatus, string> = {
  INIT: colors.grey[500],
  PENDING: colors.deepOrange[500],
  TO_PAY: colors.deepPurple[500],
  PAYED: colors.green[800],
};

export default function PaymentOutStatusChip({ status }: PaymentOutStatusProps) {
  const { t } = useTranslation();
  const statusColor = status in statusColors ? statusColors[status] : "white";

  return (
    <StatusChip
      color={statusColor}
      label={t(`STATUS.LABEL.payment_out.${status}`)}
      info={t(`STATUS.INFO.payment_out.${status}`)}
    />
  );
}
